import { all, call, fork, put, select, takeEvery, getContext, take } from 'redux-saga/effects';
import { getUniEventTypes } from '../../api/api';
import { EventTypesTypes } from './types';
import { getUniEventTypesRecordsSuccess, getUniEventTypesRecordsFailure } from './actions';
import { logout } from '../auth/actions';
import { getPathwayAndUni } from '../selectors';
import { ConfigActionTypes } from '../config/types';

function* handleGetUniEventTypes() {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);

    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetUniEventTypes');
      return;
    }
    // Check if uni config is already loaded
    const dataState = yield select((state: any) => state.data);

    // Only wait for config action if it hasn't been loaded yet
    if (!dataState.isConfigLoaded) {
      const res = yield take([ConfigActionTypes.GET_UNI_CONFIG_SUCCESS, ConfigActionTypes.GET_UNI_CONFIG_FAILURE]);
      if (res.type === ConfigActionTypes.GET_UNI_CONFIG_FAILURE) {
        throw new Error('Uni config call failed, cannot retrieve the required params for call.');
      }
    }
    const { pathway, uni } = yield select(getPathwayAndUni);
    // First arg is owner: pathway (provider) if exists, else uni
    const calendlyInterviews = yield call(getUniEventTypes, idToken, pathway || uni, pathway ? uni : undefined);

    yield put(getUniEventTypesRecordsSuccess(calendlyInterviews));
  } catch (err) {
    if (err instanceof Error) {
      yield put(getUniEventTypesRecordsFailure(err.stack!));
    } else {
      yield put(getUniEventTypesRecordsFailure('An unknown error occurred.'));
    }
  }
}

function* watchGetUniEventTypes() {
  yield takeEvery(EventTypesTypes.GET_UNI_EVENT_TYPES, handleGetUniEventTypes);
}

function* EventTypesSaga() {
  yield all([fork(watchGetUniEventTypes)]);
}

export default EventTypesSaga;
